var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-between padding-10 color-bg-fff settings-box" },
    [
      _c("div", { staticClass: "flex-start" }, [_vm._t("tools")], 2),
      _c("div", { staticClass: "flex-start" }, [
        _c("div", [_vm._t("actions")], 2),
        _c(
          "div",
          { staticClass: "flex-start margin-left-10" },
          [
            _vm.$listeners.onChange
              ? [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: "刷新",
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "padding-5 pointer",
                          on: { click: _vm.onFresh },
                        },
                        [_c("i", { staticClass: "el-icon-refresh-right" })]
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._l(_vm.list, function (item) {
              return [
                _c(item.component, {
                  key: item.name,
                  tag: "component",
                  attrs: { localColumns: _vm.localColumns, item: item },
                  on: {
                    setTableAlign: _vm.setTableAlign,
                    setTableBorder: _vm.setTableBorder,
                  },
                }),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }